import MasterService from "./MasterService";

const CommonServiceId = {
    ...MasterService,
    getUserDetail(params: any) {
        return this.post('/agency/getUserDetail', params)
    },
    saveFeedback(params: any) {
        return this.post('/common/feedback', params)
    },
    getNotificationCount(params: any) {
        return this.post('/notification/fcm/unread_count_history', params)
    },
    getNotificationList(params: any) {
        return this.post('/notification/fcm/get_notification_history', params)
    },
    readNotificationHistory(params: any) {
        return this.post('/notification/fcm/read_notification_history', params)
    },
    getFormFields(params: any, headers?: any) {
        return this.post('/common/getFormFields', params, headers)
    },
    getLeadDocumentList(params: any) {
        return this.post('/common/getLeadDocumentList', params)
    },
    getBrandList(params: object){
        return this.post('/mmv/getBrandList',params);
    },
    getParentModelList(params: object){
        return this.post('/mmv/getParentModelList',params);
    },
    getVersionList(params: object){
        return this.post('/mmv/getVersionList',params);
    },
    getOldCarPrice(params: object){
        return this.post('/mmv/getOldCarPrice',params);
    },
    getStateWiseCity(headers?: any) {
        return this.get('/common/getStateWiseCity', undefined, headers);
    },
    getDistrictList(params: object, headers?: any) {
        return this.post('/common/getDistrict', params, headers);
    },
    getStateCityList(headers?: any) {
        return this.get('/common/cityStateList', undefined, headers);
    },
    docs_upload(params: object) {
        return this.post('/core/commonservice/docs_upload',params);
    },
    getShortFileUrl(params: object) {
        return this.post('/common/getShortFileUrl', params)
    },
    getDocumentListing(params: any) {
        return this.post('/common/document_list', params)
    },
    getAgentleadHistory(params: any) {
        return this.post('/agency/getAgentleadHistory', params)
    },
    getQuotationList(params: any) {
        return this.post('/addOn/quotaionList', params)
    },
    getCreditPointListing(params: any) {
        return this.post('/commissionPoint/getCreditPointListing', params)
    },
    updateCreditPoint(params: any) {
        return this.post('/commissionPoint/updateCreditPoint', params)
    },
    getAgencyBankList(headers?: any) {
        return this.get('/agency/bankList', undefined, headers);
    },
    getLocalityList(params: object, headers?: any) {
        return this.post('/common/getLocalityList',params, headers)
    },
    getCityList(params: object, headers?: any) {
        return this.post('/common/getCityList',params, headers)
    }, 
    getStateList(headers?: any) {
        return this.post('/common/getStateList', undefined, headers)
    }
}


export default CommonServiceId;
